import React, { useState } from 'react';
const faqs = [{
  q: 'Is it suitable for Hatha, Vinyasa, and Yin?',
  a: 'Yes, the system includes sequences and modifications for all major styles, with specific variations for Hatha, Vinyasa, Yin, and therapeutic yoga.'
}, {
  q: 'Do I get the bonuses for the $37 price?',
  a: 'Yes, all 6 bonuses (value $149 AUD) are included for free if you join today during the launch offer.'
}, {
  q: 'Can I use this if I’m a newly graduated teacher?',
  a: 'Absolutely. This is the "confident start" every new teacher needs — with progressive sequences from beginner to advanced level and clear pedagogical guidelines.'
}, {
  q: 'What format is the material in?',
  a: 'High-quality, interactive PDFs compatible with any device — tablet, smartphone, PC — and ready for A4 printing to take into the studio. No special software required.'
}, {
  q: 'How long do I have access?',
  a: 'Forever. It’s a one-time purchase with lifetime access — no subscriptions, no recurring payments, no expiry date.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-135">
      <div className="max-w-3xl mx-auto" data-id="element-136">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-137">
          Frequently Asked Questions
        </h2>

        <div className="space-y-4 mb-16" data-id="element-138">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-139">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-140">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-141">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-142">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-143">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-144">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        <div className="text-center relative" data-id="element-145">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-146"></div>
          <a href="#pricing" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Yoga Ready — The Complete Kit',
              content_type: 'product',
              value: 37,
              currency: 'AUD'
            });
          }
        }} className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-147">
            🚀 YES! LEVEL UP MY TEACHING FOR $37
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-148">
            <span data-id="element-149">⚡ Instant Access</span>
            <span data-id="element-150">•</span>
            <span data-id="element-151">🛡️ 30-Day Guarantee</span>
          </p>
        </div>
      </div>
    </section>;
}